/**
 * Thiết lập i18n cho các màn hình nghiệp vụ Dự toán ngân sách
 * Mỗi màn hình tạo 1 object
 */
export default {
  // Thiết lập chỉ tiêu thu, chi
  BUPlanTemplate: {
    CreateFormularTitle: 'Thiết lập công thức',
    CreateByAccount: 'Lập theo tài khoản',
    CreateByMLNS: 'Lập theo MLNS',
    CreateByMLNSDevelopment: 'Lập theo MLNS - Chi đầu tư phát triển',
    CreateByMLNSPermanent: 'Lập theo MLNS - Chi thường xuyên',
    ListPlanActivityHasPlusToParent: 'Danh sách chỉ tiêu cộng lên',
    CreateByMLNSTooltip: 'Lập theo Mục lục ngân sách',
    PlusToParent: 'Cộng lên chỉ tiêu tổng hợp',
    Note: 'Ghi chú',
    TemplateParent: 'Thuộc chỉ tiêu',
    ActivityCode: 'Mã số *',
    ActivityName: 'Nội dung *',
    CommuneReceiptPercentage: 'Tỷ lệ xã được hưởng (%)',
    ExpanseDevelopment: 'Chi đầu tư phát triển',
    ExpansePermanent: 'Chi thường xuyên',
    Target: 'Chỉ tiêu ',
  },

  BUReportSpendingTarget: {
    SetupReport: 'Thiết lập báo cáo',
    FormulaChecking: 'Kiểm tra công thức',
  },

  BUPlanActivityTempSymmet: {
    ViewSelected: 'Hiển thị chỉ tiêu đã tích chọn',
    PopupTitle: 'Thiết lập báo cáo',
    IncomeTitle: 'Nội dung thu',
    SpendTitle: 'Nội dung chi',
    MasterGridTitle: 'Nội dung hiển thị trên báo cáo',
    DetailGridTitle: 'Chọn chỉ tiêu lấy số liệu lên: ',
    CheckFormular: 'Kiểm tra công thức',
    TotalRow: 'Số dòng: <b>{0}</b>',
    TotalTarget: 'Chỉ tiêu đã tích: ',
    GetDefault: 'Lấy lại mặc định',
  },
  BUPlanReceipt: {
    GenerateNewBudget: 'Lập dự toán mới dựa vào dự toán năm',
    UpdateTemplate: 'Cập nhật chỉ tiêu',
    CalculateData: 'Tính DT từ MLNS',
    SummaryReceiptSupplement: 'Tổng hợp từ bổ sung dự toán thu theo MLNS',
    SummaryReceiptAdjust: 'Tổng hợp từ điều chỉnh dự toán thu theo MLNS',
    SummaryExpenseSupplement: 'Tổng hợp từ bổ sung dự toán chi theo MLNS',
    SummaryExpenseAdjust: 'Tổng hợp từ điều chỉnh dự toán chi theo MLNS',
    SaveFailTitle: 'Cất không thành công',
    RequireMoney: 'Số tiền không được phép để trống.',

    RequireSource: 'Nguồn không được phép để trống.',
    RequireChapter: 'Chương không được phép để trống.',
    RequireKindItem: 'Loại không được phép để trống.',
    RequireSubKindItem: 'Khoản không được phép để trống.',
    RequireGroupItem: 'Nhóm mục chi không được phép để trống.',
    RequireItem: 'Mục không được phép để trống.',
    RequireSubItem: 'Tiểu mục không được phép để trống.',
    RequireItemDetail: 'Tiết không được phép để trống.',

    DuplicateMLNS: 'Có ít nhất 2 dòng dự toán trùng MLNS, xin vui lòng nhập lại dữ liệu.',
    DetailNoData: 'Vui lòng chọn ít nhất một dòng dữ liệu.',
    DuplicateVoucherMLNS: 'Dự toán thu đầu năm theo MLNS năm {0} đã tồn tại. Vui lòng kiểm tra lại.',
    DuplicateVoucherTT342: 'Dự toán thu theo NDKT (Mẫu TT342/2016/TT-BTC) - năm {0} đã tồn tại. Vui lòng chọn lại.',
    DuplicateVoucherTT343: 'Dự toán thu theo NDKT (Mẫu TT343/2016/TT-BTC) - năm {0} đã tồn tại. Vui lòng chọn lại.',
    DuplicateVoucherTT344: 'Dự toán thu theo NDKT (Mẫu TT344/2016/TT-BTC) - năm {0} đã tồn tại. Vui lòng chọn lại.',
  },
  BUPlanExpense: {
    SaveFailTitle: 'Cất không thành công',
    DuplicateMLNS: 'Có ít nhất 2 dòng dự toán trùng MLNS, xin vui lòng nhập lại dữ liệu.',
    DetailNoData: 'Vui lòng chọn ít nhất một dòng dữ liệu.',
    DuplicateVoucherMLNS: 'Dự toán chi đầu năm theo MLNS năm {0} đã tồn tại. Vui lòng kiểm tra lại.',
    DuplicateVoucherTT342: 'Dự toán chi theo NDKT (Mẫu TT342/2016/TT-BTC) - năm {0} đã tồn tại. Vui lòng chọn lại.',
    DuplicateVoucherTT343: 'Dự toán chi theo NDKT (Mẫu TT343/2016/TT-BTC) - năm {0} đã tồn tại. Vui lòng chọn lại.',
    DuplicateVoucherTT344: 'Dự toán chi theo NDKT (Mẫu TT344/2016/TT-BTC) - năm {0} đã tồn tại. Vui lòng chọn lại.',
    DuplicateVoucherTT344Source:
      'Dự toán đầu năm theo <span class="color-green">{0} năm {1}</span> đã tồn tại. Vui lòng chọn lại.',
  },
  ChooseBudget: {
    Title: 'Chọn chứng từ',
    NoData: 'Không có dữ liệu',
    NoVoucherMLNSReceipt: 'Không tồn tại bản Tổng hợp dự toán thu theo MLNS nào. Vui lòng kiểm tra lại.',
    NoVoucherMLNSExpense: 'Không tồn tại bản Tổng hợp dự toán chi theo MLNS nào. Vui lòng kiểm tra lại.',
  },

  CommonDuplicateMsg: 'Dự toán đã tồn tại. Vui lòng kiểm tra lại.',
  BaseDuplicateMsg: '{0} năm {1} đã tồn tại. Vui lòng kiểm tra lại.',
  BaseNDKTDuplicateMsg: '{0} - năm {1} đã tồn tại. Vui lòng kiểm tra lại.',
};
